import script from "./LokasView.vue?vue&type=script&setup=true&lang=js"
export * from "./LokasView.vue?vue&type=script&setup=true&lang=js"

import "./LokasView.vue?vue&type=style&index=0&id=8b07647a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b07647a"]])

export default __exports__